import React from 'react';
import RestAssuredRegister from '../component/RestAssuredRegister';

function RestAssuredTraining() {
  return (
    <div id="myContactus">
      <RestAssuredRegister />
    </div>
  );
}

export default RestAssuredTraining;
